import { IRI } from '@/api';

export default {
  payload: (state) => {
    const payload = Object.assign({}, state.item);
    payload.questions.forEach(question => {
      if (!question.id) {
        return question;
      }

      const id = question.id.replace(IRI.question, '');
      question['id'] = `${IRI.question}${id}`;
      question.answers.forEach(answer => {
        if (!answer.id) {
          return answer;
        }

        const id = answer.id.replace(IRI.answer, '');
        answer['id'] = `${IRI.answer}${id}`;
        return answer;
      });
      return question;
    });
    console.log(state.item);
    console.log(payload);
    return payload;
  },
};
